import FormOrder from '../../../../types/api/form-order'
import { FailureReason } from '../../../../types/api/form'
import { FormsTableRow } from '../types/forms-table-row'

export function FormsDataSource(formOrders: FormOrder[]): FormsTableRow[] {
    return formOrders.flatMap(order => {
        const forms = order.forms ?? []
        const count = forms.length

        const orderFields = {
            orderId: order.id,
            orderDocumentId: order.documentId,
            orderStatus: order.orderStatus,
            orderCreatedAt: order.createdAt,
            orderEstimatedDate: order.estimatedDate,
            formsCount: count,
            allFormsProcessed:
                count > 0 &&
                forms.every(
                    form =>
                        form.inStock === true ||
                        form.failureReason === FailureReason.ManufacturingDefect
                ),
            orderShipment: order.shipment,
        }

        if (count === 0) {
            return [
                {
                    key: `${order.documentId}-empty`,
                    documentId: order.documentId,
                    rowSpan: 1,
                    ...orderFields,
                } as FormsTableRow,
            ]
        }

        return forms.map((form, index) => ({
            ...form,
            key: `${order.documentId}-${form.documentId}`,
            rowSpan: index === 0 ? count : 0,
            ...orderFields,
        }))
    })
}
